import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import { ResourceRequestStatus } from '~/types';
import { useMeContext } from '~/modules/me';
import { hasProposeActionAllowed } from '~/modules/resourcing/common/components/ResourceMatchItem/permissionUtil';
import ResourceRequestChartBanner from '~/modules/resourcing/common/components/ResourceRequestChartBanner/ResourceRequestChartBanner';
import ResourceRequestProposeAllButton from './ResourceRequestProposeAllButton';

const useStyles = makeStyles(theme => ({
  root2: {
    padding: theme.spacing(1, 3, 1, 1.5)
  }
}));

export const ResourceRequestProposeAllChartBanner = ({ resourceRequests }) => {
  const me = useMeContext();
  const classes = useStyles();

  const hasPermission = hasProposeActionAllowed(me);

  const submittedResourceRequestUrisWithMatches = hasPermission
    ? resourceRequests
        .filter(
          resourceRequest =>
            resourceRequest.requestStatus === ResourceRequestStatus.Submitted &&
            resourceRequest.resourceMatches?.length
        )
        .map(resourceRequest => ({
          resourceRequest,
          userIds: [resourceRequest.resourceMatches[0].userUri]
        }))
    : [];

  return submittedResourceRequestUrisWithMatches.length > 0 ? (
    <ResourceRequestChartBanner
      messageId="resourceRequestChartBanner.delaProposeQuestion2"
      classes={classes}
    >
      <ResourceRequestProposeAllButton
        submittedResourceRequestUrisWithMatches={
          submittedResourceRequestUrisWithMatches
        }
      />
    </ResourceRequestChartBanner>
  ) : null;
};

ResourceRequestProposeAllChartBanner.propTypes = {
  resourceRequests: PropTypes.array.isRequired
};
export default ResourceRequestProposeAllChartBanner;
